export default (eventName: string, options?: Record<string, unknown>) => {
  window.dataLayer?.push({ event: eventName, ...options });
};
